import { createResourceCompanyButton } from "../../Utils/utils";
import CreateButton from "./CreateButton";

const CreateCompanyButtons = () => (
    <CreateButton
        type="company"
        create={createResourceCompanyButton}
    />
);

export default CreateCompanyButtons;
